module.exports = __webpack_public_path__ + "28588459f5ec6504f1beb230368983ca.pdf";